/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {requeueEscalatedAction} from '../api'

export const useMutationRequeueEscalatedAction = createReactQueryMutationHook('requeueEscalatedAction', requeueEscalatedAction)
